<template>
  
    <!-- Convenient -->
    <section class="section convenient-section">
        <div class="cock-img">
            <div class="cock-img-one">
                <img src="@/assets/img/icons/cock-01.svg" alt="Icon">
            </div>
            <div class="cock-img-two">
                <img src="@/assets/img/icons/cock-02.svg" alt="Icon">
            </div>
            <div class="cock-circle">
                <img src="@/assets/img/bg/cock-shape.png" alt="Icon">
            </div>
        </div>
        <div class="container">
            <div class="convenient-content aos" data-aos="fade-up">
                <h2>Chính xác - chuyên nghiệp - phong phú</h2>
                <p>Hệ thống quản lý giải đấu và thông tin vận động viên bộ môn cầu lông hàng đầu tại Việt Nam.</p>
            </div>
            <div class="convenient-btns aos" data-aos="fade-up">
                <router-link to="/giai-dau" class="btn btn-primary d-inline-flex align-items-center tw-me-2">
                    Đăng ký <span class="lh-1"><i class="feather-arrow-right-circle ms-2"></i></span>
                </router-link>
                <router-link to="/lien-he" class="btn btn-secondary d-inline-flex align-items-center">
                    Liên hệ <span class="lh-1"><i class="feather-arrow-right-circle ms-2"></i></span>
                </router-link>
            </div>
        </div>
    </section>
    <!-- /Convenient -->
</template>

<script>
import Service from '@/assets/json/home-service.json'
export default {
    data() {
        return {
            Service: Service
        }
    },
}
</script>